import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    MvsCreateObjectTicketComponent
} from "../component/protected-components/create-object-ticket/mvs-create-object-ticket.component";
import {
    TicketTypeObjectComponent
} from "../component/protected-components/object-component/ticket-type-object-component/ticket-type-object.component";
import {
    TicketTypeObjectSideComponent
} from "../component/protected-components/object-component/ticket-type-object-component/view/ticket-type-object-component-side/ticket-type-object-side.component";
import {
    TicketTypeObjectFullComponent
} from "../component/protected-components/object-component/ticket-type-object-component/view/ticket-type-object-component-full/ticket-type-object-full.component";
import {
    ObjectTicketGroupFilterComponent
} from "../component/protected-components/object-ticket-group-filter/object-ticket-group-filter.component";
import {
    CreateTmTicketActionsComponent
} from "../component/protected-components/ticket/ticket-components/create-tm-ticket-actions/create-tm-ticket-actions.component";
import {
    TmTicketConsultantComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket/tm-ticket-consultant.component";
import {
    TmTicketActionsComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-actions/tm-ticket-actions.component";
import {
    TmTicketAttachmentComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-attachement/tm-ticket-attachment.component";
import {
    TmTicketCommentHistoryComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-comment-history/tm-ticket-comment-history.component";
import {
    TmTicketCompletionComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-completion/tm-ticket-completion.component";
import {
    TmTicketCreateConsultantComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-create/tm-ticket-create-consultant.component";
import {
    TmTicketCustomerContactComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-customer-contact/tm-ticket-customer-contact.component";
import {
    TmTicketLandingComponentsComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-landing-components/tm-ticket-landing-components.component";
import {
    TmTicketSelectPredefinedTaskComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-select-predefined-task/tm-ticket-select-predefined-task.component";
import {
    TmTicketSubNavigationTasksComponent
} from "../component/protected-components/ticket/ticket-components/tm-ticket-sub-navigation-tasks/tm-ticket-sub-navigation-tasks.component";
import {TicketComponent} from "../component/protected-components/ticket/ticket.component";
import {
    TicketHistoryComponent
} from "../component/protected-components/ticket-comment-history/ticket-comment-history.component";
import {
    TicketCompleteFormComponent
} from "../component/protected-components/ticket-complete-form/ticket-complete-form.component";
import {
    TicketManagementComponent
} from "../component/protected-components/ticket-management/ticket-management.component";
import {
    TicketFilterGroupListComponent
} from "../component/protected-components/ticket-management/components/ticket-filter-group-list-component/ticket-filter-group-list.component";
import {
    TicketObjectInlineComponent
} from "../component/protected-components/ticket-object-inline/ticket-object-inline.component";
import {
    TicketQuickCreateComponent
} from "../component/protected-components/ticket-quick-create/ticket-quick-create.component";
import {
    TmTicketAppointmentInlineComponent
} from "../component/protected-components/tm-ticket-appointment-inline-component/tm-ticket-appointment-inline-component";
import {
    TmTicketWfProcessStepActivityComponent
} from "../component/protected-components/wf/tm-ticket-wf-process-step-activity/tm-ticket-wf-process-step-activity.component";
import {
    TmMyTicketsComponent
} from "../component/protected-components/consultant-component/tm-my-tickets/tm-my-tickets.component";
import {TicketsPage} from "../page/consultant-page/page/tickets-page/tickets.page";

const tmModuleEntry: TestModuleDefinition = {
    key: 'tm',
    label: 'Ticket (tm)',
    components: [
        {
            key: 'MvsCreateObjectTicketComponent',
            component: MvsCreateObjectTicketComponent,
            selector: 'mvs-create-ticket-object',
            label: 'Create Ticket Object',
            type: 'Component',
        },
        {
            key: 'TicketTypeObjectComponent',
            component: TicketTypeObjectComponent,
            selector: 'ticket-type-object-component',
            label: 'Ticket Type Object Component',
            type: 'ObjetBaseComponent',
        },
        {
            key: 'TicketTypeObjectSideComponent',
            component: TicketTypeObjectSideComponent,
            selector: 'ticket-type-object-component-side',
            label: 'Ticket Type Object Side Component',
            type: 'Component',
        },
        {
            key: 'TicketTypeObjectFullComponent',
            component: TicketTypeObjectFullComponent,
            selector: 'ticket-type-object-component-full',
            label: 'Ticket Type Object Full Component',
            type: 'Component',
        },
        {
            key: 'ObjectTicketGroupFilterComponent',
            component: ObjectTicketGroupFilterComponent,
            selector: 'object-ticket-group-filter',
            label: 'Object Ticket Group Filter',
            type: 'ObjetBaseComponent',
        },
        {
            key: 'CreateTmTicketActionsComponent',
            component: CreateTmTicketActionsComponent,
            selector: 'create-tm-ticket-actions',
            label: 'Create Ticket Actions Component',
            type: 'Component',
        },
        {
            key: 'TmTicketComponent',
            component: TmTicketConsultantComponent,
            selector: 'tm-ticket',
            label: 'Tm Ticket Component',
            type: 'ObjetBaseComponent',
        },
        {
            key: 'TmTicketActionsComponent',
            component: TmTicketActionsComponent,
            selector: 'tm-ticket-actions',
            label: 'Ticket Actions',
            type: 'Component',
        },
        {
            key: 'TmTicketAttachmentComponent',
            component: TmTicketAttachmentComponent,
            selector: 'tm-ticket-attachment',
            label: 'Ticket Attachment Component',
            type: 'Component',
        },
        {
            key: 'TmTicketCommentHistoryComponent',
            component: TmTicketCommentHistoryComponent,
            selector: 'tm-ticket-comment-history',
            label: 'Ticket Comment history',
            type: 'Component',
        },
        {
            key: 'TmTicketCompletionComponent',
            component: TmTicketCompletionComponent,
            selector: 'tm-ticket-completion',
            label: 'Ticket Completion',
            type: 'Component',
        },
        {
            key: 'TmTicketCreateComponent',
            component: TmTicketCreateConsultantComponent,
            selector: 'tm-ticket-create',
            label: 'Create Ticket Component',
            type: 'ObjetBaseComponent',
        },
        {
            key: 'TmTicketCustomerContactComponent',
            component: TmTicketCustomerContactComponent,
            selector: 'tm-ticket-customer-contact',
            label: 'Ticket Customer Contact',
            type: 'Component',
        },
        {
            key: 'TmTicketLandingComponentsComponent',
            component: TmTicketLandingComponentsComponent,
            selector: 'tm-ticket-landing-components',
            label: 'Ticket Landing Components',
            type: 'Component',
        },
        {
            key: 'TmTicketSelectPredefinedTaskComponent',
            component: TmTicketSelectPredefinedTaskComponent,
            selector: 'tm-ticket-select-predefine-task',
            label: 'Ticket Select Predefined Task',
            type: 'Component',
        },
        {
            key: 'TmTicketSubNavigationTasksComponent',
            component: TmTicketSubNavigationTasksComponent,
            selector: 'tm-ticket-sub-navigation-tasks',
            label: 'Ticket Sub Navigation Tasks',
            type: 'Component',
        },
        {
            key: 'TicketComponent',
            component: TicketComponent,
            selector: 'mvs-tm-ticket',
            label: 'Ticket Component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'TicketHistoryComponent',
            component: TicketHistoryComponent,
            selector: 'mvs-ticket-history',
            label: 'Ticket History',
            type: 'Component',
        },
        {
            key: 'TicketCompleteFormComponent',
            component: TicketCompleteFormComponent,
            selector: 'ticket-complete-form',
            label: 'Ticket Complete Form',
            type: 'Component',
        },
        {
            key: 'TicketManagementComponent',
            component: TicketManagementComponent,
            selector: 'ticket-management',
            label: 'Ticket Management',
            type: 'PageComponent',
        },
        {
            key: 'TicketFilterGroupListComponent',
            component: TicketFilterGroupListComponent,
            selector: 'ticket-filter-group-list',
            label: 'Ticket Filter List Component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'TicketObjectInlineComponent',
            component: TicketObjectInlineComponent,
            selector: 'ticket-object-inline',
            label: 'Ticket Object Inline',
            type: 'Component',
        },
        {
            key: 'TicketQuickCreateComponent',
            component: TicketQuickCreateComponent,
            selector: 'ticket-quick-create',
            label: 'Ticket Quick Create',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'TmTicketAppointmentInlineComponent',
            component: TmTicketAppointmentInlineComponent,
            selector: 'tm-ticket-appointment-inline-component',
            label: 'Ticket Appointment Inline',
            type: 'Component',
        },
        {
            key: 'TmTicketWfProcessStepActivityComponent',
            component: TmTicketWfProcessStepActivityComponent,
            selector: 'mvs-wf-process-step-activity-ticket-object',
            label: 'Ticket Wf Process Step Activity',
            type: 'Component',
        },
        {
            key: 'TmMyTicketsComponent',
            component: TmMyTicketsComponent,
            selector: 'tm-my-tickets',
            type: 'CoreComponent',
            label: 'my tickets component Consultant'
        },
        {
            key: 'TicketsPage',
            component: TicketsPage,
            selector: 'tm-tickets-page',
            type: 'CorePage',
            label: 'tickets page Consultant'
        },

    ]
}

export const TM_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: tmModuleEntry, multi: true},
]